/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hx-profile[_ngcontent-%COMP%]{background-color:rgba(255,255,255,.8)}.header[_ngcontent-%COMP%]{background-color:#fff}"];
export { styles as styles };
